module.exports = "/_next/static/images/3bf6153df95a6dc0dca2e936648b4a1b-instant-pay.jpg";